import { jsx as r } from "react/jsx-runtime";
import "react";
import p from "prop-types";
import { Box as t } from "../Box/Box.js";
const e = ({ children: o }) => /* @__PURE__ */ r(t, { paddingLeft: 10, paddingRight: 10, children: o });
e.propTypes = {
  children: p.node.isRequired
};
export {
  e as ContentLayout
};
